import { useMemo } from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";

import { SocialLinksContainer, LinkIcon } from "./styles";

import { SocialLinksProps } from "./types";
import { Icons, IconsSrc } from "@itchannelplus/assets/icons";

export const SocialLinks = ({
  theme = "black",
  hideInMobile = false,
  links,
  ...props
}: SocialLinksProps) => {
  const t = useTranslations("common");
  const instagramIcon = useMemo(
    () => (theme === "white" ? IconsSrc.instagramWhite : IconsSrc.instagramBlack),
    [theme],
  );
  const facebookIcon = useMemo(
    () => (theme === "white" ? IconsSrc.facebookWhite : IconsSrc.facebookBlack),
    [theme],
  );
  const linkedinIcon = useMemo(
    () => (theme === "white" ? IconsSrc.linkedinWhite : IconsSrc.linkedinBlack),
    [theme],
  );

  return (
    <SocialLinksContainer {...{ hideInMobile }} {...props}>
      { !!links?.instagram && <Link href={links?.instagram || t("social.instagram")} passHref target={"_blank"}>
        <LinkIcon src={instagramIcon} alt="Instagram" width={20} height={20} />
      </Link> }
      { !!links?.facebook && <Link href={links?.facebook || t("social.facebook")} passHref target={"_blank"}>
        <LinkIcon src={facebookIcon} alt="Facebook" width={20} height={20} />
      </Link>}
      { !!links?.linkedin && <Link href={links?.linkedin} passHref target={"_blank"}>
        <LinkIcon src={linkedinIcon} alt="Linkedin" width={20} height={20} />
      </Link> }
    </SocialLinksContainer>
  );
};
